import React from 'react';
import { FormattedMessage } from 'react-intl';
import Modal from './../../../reusable/Modal/Modal.index';
import reduxStore from './../../../reduxStore';
import utils from './../../../utils/utilities';

export default class EditActivation extends React.Component {

    constructor(props) {
        super(props);

        this.state = {active: this.props.data, isModalVisible: false};

        this.activateEntity = this.activateEntity.bind(this);
        this.toggleModalVisibility = this.toggleModalVisibility.bind(this);
        this.deactivateEntity = this.deactivateEntity.bind(this);

    }

    activateEntity() {
        if (!this.state.active) {
            this.setState({
                active: true
            });
            this.props.handleChange("active", true);
        }
    }

    toggleModalVisibility() {
        this.setState({isModalVisible: this.state.active && !this.state.isModalVisible});
    }

    deactivateEntity() {
        if (this.state.active) {
            this.setState({
                active:         false,
                isModalVisible: false
            });
            this.props.handleChange("active", false);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.data != this.state.active) {
            this.setState({active: nextProps.data})
        }
    }

    render() {

        let entityStatusStyles = this.state.active ? "active" : "inactive";
        let modalButtons = [
            {
                text:    <FormattedMessage id="Entities_Edit_UIText_editThirdParty.deactivate" />,
                primary: true,
                click:   this.deactivateEntity
            },
            {
                text:  <FormattedMessage id="General_CoreFunctionality_UIText_general.cancel" />,
                click: this.toggleModalVisibility,
                tabIndex: 1
            }
        ];

        return (
            <div className="edit-third-party__about__input-group about__status-input-group">
                <div className="row-label">
                    <FormattedMessage id="Entities_Edit_UIText_editThirdParty.statusLabel" />
                </div>

                <div className={"status-buttons " + entityStatusStyles}>
                    <button type="button"
                            className="status-button button-activate"
                            onClick={this.activateEntity} >
                        <FormattedMessage id="Entities_Edit_UIText_editThirdParty.activeLabel" />
                    </button>
                    <button type="button"
                            className="status-button button-deactivate"
                            onClick={this.props.enableDeactivateWarning ? this.toggleModalVisibility : this.deactivateEntity} >
                        <FormattedMessage id="Entities_Edit_UIText_editThirdParty.inactiveLabel" />
                    </button>
                </div>

                {
                    this.state.active ?
                        <div className="status-info">
                            <span className="la-Correct"></span>
                            <FormattedMessage id="Entities_Edit_UIText_editThirdParty.disclaimerActive" />
                        </div>
                        :
                        <div className="status-info">
                            <span className="la-Incorrect"></span>
                            <FormattedMessage id="Entities_Edit_UIText_editThirdParty.disclaimerInactive" />
                        </div>
                }

                {
                    this.state.isModalVisible ?
                        <Modal buttons={modalButtons} closeButtonHandler={this.toggleModalVisibility}>
                            <h2 className="modal-header">
                                <FormattedMessage id="Entities_Edit_UIText_editThirdParty.modalHeader" />
                            </h2>

                            <div className="divider"></div>
                            <div className="modal-check">
                                <div className="warning">
                                    <span className="la-Error"></span>
                                    <FormattedMessage id="Entities_Edit_UIText_editThirdParty.modalWarningP1" />
                                </div>
                                <FormattedMessage id="Entities_Edit_UIText_editThirdParty.modalWarningP2" />
                            </div>
                        </Modal>
                        :
                        null
                }

            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/scripts/pages/EditThirdParty/components/EditActivation.jsx